const modal = require('../support/Modal');

/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */
$(function () {
    'use strict';

    /**
     * Show modal when section trigger it.
     */

    if ($('#benefitModal').length > 0) {
        modal.trigger($('#benefitModal'));
    }

    if ($('#ticketModal').length > 0) {
        modal.trigger($('#ticketModal'));
    }

    if ($('#experienceModal').length > 0) {
        modal.trigger($('#experienceModal'));
    }

    if ($('#movieTicketModal').length > 0) {
        modal.trigger($('#movieTicketModal'));
    }

    if ($('#trialEndModal').length > 0) {
        modal.trigger($('#trialEndModal'));
    }

    $('.movie-ticket-terms').on('click', (e) => {
        e.preventDefault();

        modal.trigger($('#movietermsModal'));
    });

    /*
    if ($('#cancelConfirmationModal').length > 0) {
        modal.trigger($('#cancelConfirmationModal'));
    }

    if ($('#welcomeModal').length > 0) {
        modal.trigger($('#welcomeModal'));
    }

    if ($('#registerConfirmationModal').length > 0) {
        modal.trigger($('#registerConfirmationModal'));
    }

    if ($('#modifyPasswordModal').length > 0) {
        modal.trigger($('#modifyPasswordModal'));
    }

    if ($('#registerPlanModal').length > 0) {
        modal.trigger($('#registerPlanModal'));
    } */
});
